/**
 * Normalize a free-form item name for matching against PantryKnowledge aliases
 * and de-duplication checks.
 */
export function normalizeName(input: string): string {
  return input.trim().toLowerCase().replace(/\s+/g, ' ');
}
